import {isBoolean} from 'lodash'

export const getBorderRadius = borderRadius => {
	if (!borderRadius) return

	if (isBoolean(borderRadius)) borderRadius = 4
	if (borderRadius === 'large') borderRadius = 8

	return borderRadius
}
